export default {
  Table_Common: {
    TuoDong: '拖動',
    ZhuanJieMa_MingCheng: '轉介碼名稱',
    ZhuanJie_Ma: '轉介碼',
    TingYon_ZhuanTai: '停用狀態',
    ChuangJian_ShiJian: '創建時間',
    JiaZai_Zhong: '加載中',
    ShouJi_HaoMa: '手機號碼',
    DianHua: '電話',
    XingBie: '性別',
    ZhiGong_LeiBie: '職工類別',
    ZhenJin: '診金',
    Yuan: '元',
    JueSe: '角色',
    YuanGong_ZhuangTai: '員工狀態',
    QiYong: '啓用',
    TingYong: '停用',
    ShiFou_CanYu_PaiBan: '是否參與排班',
    ShiFou_PaiBan: '是否排班',
    Shi: '是',
    Fou: '否',
    PaiBan: '排班',
    YouXiang: '郵箱',
    ChuSheng_RiQi: '出生日期',
    CaoZuo: '操作',
    Nan: '男',
    Nv: '女',
    MiaoShu: '描述',
    CaiDan_MingCheng: '菜單名稱',
    LuYou: '路由',
    GongNeng_QuanXian: '功能權限',
    YaoFei: '藥費',
    ZhenJiu_JinE: '針灸金額',
    TaoPiao: '套票',
    YouFei: '郵費',
    ZhenJin_JinE: '診金金額',
    TuiNa_ZhengGu: '推拿/正骨',
    BaGuan_JinE: '拔罐金額',
    YouHuiQuan_MingCheng: '優惠券名稱',
    QiYong_ZhuangTai: '啟用狀態',
    MianE: '面額',
    ManJian_MuBiao_JinE: '滿減目標金額',
    ShiYong_QingKuang: '使用情況',
    Yi_ShiYong: '已使用',
    Yi_FaFang: '已發放',
    ShiYong_DanJu: '適用單據',
    GuoQi_ShiJian: '過期時間',
    GuoQi_RiQi: '過期日期',
    LaiYuan: '來源',
    YiShi_Duan: '醫師端',
    GuanLi_Duan: '管理端',
    JianDang_ShiJian: '建檔時間',
    ShouHuo_Ren: '收貨人',
    YiDong_SheZhi: '移動設置',
    MoRen_DiZhi: '默認地址',
    SheWei_MoRen: '設為默認',
    YaoPin_MingCheng_En: '藥品名稱(En)',
    BianMa: '編碼',
    GuiGe_En: '規格(En)',
    NongSuo: '濃縮',
    JingZhong: '淨重',
    DanWei_ChengBen_Jia: '單位成本價',
    DanWei_ShouJia: '單位售價',
    KuCun: '庫存',
    ChuFang_DanWei: '處方單位',
    YaoPin_ZhuangTai: '藥品狀態',
    ChengFen_Yao: '成分藥',
    DingDan_ZhuangTai: '訂單狀態',
    DingDan_JinE: '訂單金額',
    XiaDan_Ren: '下單人',
    ShenPi_Ren: '審批人',
    GengXin_ShiJian: '更新時間',
    ShenPi_ShiJian: '審批時間',
    ChengBen_Jia: '成本價',
    XiaDan_ShuLiang: '下單數量',
    QianShou_ShuLiang: '簽收數量',
    Yi_QianShou: '已簽收',
    BenCi_QianShou: '本次簽收',
    QianShou_ShiJian: '簽收時間',
    ShenPi_Zhong: '審批中',
    Dai_QianShou: '待簽收',
    Yi_WanCheng: '已完成',
    BoHui: '駁回',
    Yi_ZuoFei: '已作廢',
    DiaoZheng_RenYuan: '調整人員',
    ShenHe_RenYuan: '審核人員',
    DiaoZheng_Qian_KuCun: '調整前庫存',
    DiaoZheng: '調整',
    DiaoZheng_Hou_KuCun: '調整後庫存',
    XiangMu_MingCheng: '項目名稱',
    ZhongLei: '種類',
    JiFei: '計費',
    HanLiang: '含量',
    ChongZhi_JinE: '充值金額',
    ZengSong_JinE: '贈送金額',
    ShiFou_ShouChong: '是否首充',
    YuE: '餘額',
    GuiGe: '規格',
    JingMai: '經脈',
    XueWei: '穴位',
    FangFa: '方法',
    WeiZhi: '位置',
    DanWei: '單位',
    XiangMu: '項目',
    ZiTou: '字頭',
    RiQi_GeShi: '日期格式',
    BuLing: '補零',
    QiShi: '起始',
    LeiXing: '類型',
    ShuLiang: '數量',
    KeHu_BianHao: '客戶編號',
    JiuZhen: '就診',
    HeJi: '合計',
    XueWei_GeShu: '穴位個數',
    DanJu_LeiXing: '單據類型',
    ShiYong_CiShu: '使用次數',
    YouHui_JinE_XianZhi: '優惠金額限制',
    ZhongYi_ChuFang: '中醫處方',
    ZhongYi_ChuFang_Zhen: '中醫處方(針)',
    ZhongYi_ChuFang_Tui: '中醫處方(推)',
    ZhongYi_ChuFang_Ba: '中醫處方(拔)',
    BingLi_BaoGao: '病歷報告',
    BingJia_ZhengMingShu: '病假證明書',
    DaoZhen_ZhengMingShu: '到診證明書',
    HuaiYun_ZhengMingShu: '懷孕證明書',
    ShouJu: '收據',
    DaYin_ShiJian: '打印時間',
    DaYin_Ren: '打印人',
    GuanLiYuan: '管理員',
    Biaozhun: '標準',
    GuiGe_BianMa: '規格編碼',
    PinYin: '拼音',
    YaoPing_GuiGe: '藥品規格',
    NongDu: '濃度',
    ShiFou_NongSuo: '是否濃縮',
    TiaoMa: '條碼',
    PiCiHao: '批次號',
  },
}
